// ==============================|| OVERRIDES - TABS ||============================== //

export default function Tabs() {
  return {
    MuiTabs: {
      defaultProps: {
        variant: 'scrollable',
        scrollButtons: 'auto',
        allowScrollButtonsMobile: true
      },
      styleOverrides: {
        root: {
          minHeight: 38,
          maxWidth: '100%'
        },
        scrollableX: {
          overflowX: 'auto !important',
          WebkitOverflowScrolling: 'touch'
        },
        vertical: {
          overflow: 'visible'
        }
      }
    }
  };
}
